/* eslint-disable */
export default {
  to: 'Para:',
  transferTo: 'Transferir para',
  blindTransfer: 'Transferir',
  warmTransfer: 'Perguntar primeiro',
  enterNameOrNumber: 'Inserir número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
